export default __webpack_public_path__ + "static/media/logo.460681f8.png";